import { ManageAccounts, Security, SvgIconComponent } from '@mui/icons-material'
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import ProfileSettings from 'components/profile-settings'
import SecuritySettings from 'components/security-settings'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

interface AccountSetting {
  name: string
  icon: SvgIconComponent
  tab: React.FC<any>
}

type AppProps = StateProps & DispatchProps

const AccountSettingsFC: React.FC<any> = (props: AppProps) => {
  const { theme } = props

  const availableSettings: AccountSetting[] = [
    {
      name: 'Profile',
      icon: ManageAccounts,
      tab: ProfileSettings
    },
    {
      name: 'Security',
      icon: Security,
      tab: SecuritySettings
    }
  ]

  const [selectedSetting, setSelectedSetting] = React.useState(
    availableSettings[0]
  )

  const SelectedTab = selectedSetting.tab

  return (
    <Box
      minWidth={1000}
      width={'30vw'}
      display={'flex'}
      height={700}
      borderTop={1}
      borderColor={theme.secondaryColor}
      marginTop={1}
    >
      <Box
        height={1}
        minWidth={210}
        width={0.3}
        borderRight={1}
        borderColor={theme.secondaryColor}
        display={'flex'}
        flexDirection={'column'}
      >
        <List>
          {availableSettings.map((setting, index) => {
            const IconComponent = setting.icon
            return (
              <ListItem key={index}>
                <ListItemButton
                  onClick={() => setSelectedSetting(setting)}
                  disabled={setting.name === selectedSetting.name}
                >
                  <ListItemIcon>
                    <IconComponent color={'primary'} />
                  </ListItemIcon>
                  <ListItemText primary={setting.name} />
                </ListItemButton>
              </ListItem>
            )
          })}
        </List>
      </Box>
      <Box height={1} minWidth={590} width={0.7}>
        <SelectedTab />
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const AccountSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountSettingsFC)

export default AccountSettings
